var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccordionClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.14746 1.39793L5.39746 5.14793C5.3452 5.20037 5.28311 5.24198 5.21473 5.27037C5.14636 5.29876 5.07306 5.31337 4.99902 5.31337C4.92499 5.31337 4.85169 5.29876 4.78331 5.27037C4.71494 5.24198 4.65284 5.20037 4.60058 5.14793L0.850585 1.39793C0.744913 1.29226 0.685547 1.14893 0.685547 0.999491C0.685547 0.850048 0.744913 0.706726 0.850585 0.601054C0.956257 0.495382 1.09958 0.436016 1.24902 0.436016C1.39847 0.436016 1.54179 0.495382 1.64746 0.601054L4.99949 3.95308L8.35152 0.600585C8.45719 0.494913 8.60052 0.435547 8.74996 0.435547C8.8994 0.435547 9.04272 0.494913 9.1484 0.600585C9.25407 0.706258 9.31344 0.84958 9.31344 0.999023C9.31344 1.14847 9.25407 1.29179 9.1484 1.39746L9.14746 1.39793Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionClose);
export default __webpack_public_path__ + "static/media/accordion-close.6f3185a042d3a9717db47d73bd636a71.svg";
export { ForwardRef as ReactComponent };